var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-form',{attrs:{"title":"データ取引会員サイト","show-domain":true,"domain-list":_vm.domainList,"err-message":_vm.message,"placeholder-user":"user id"},on:{"submit":_vm.login}})}
var staticRenderFns = []

export { render, staticRenderFns }